import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ACCOUNTS_SEARCH_QUERY_KEY} from "../queryKeys";

export type ReachAccountSearchResult = {
  account_id: number;
  account_public_id: string;
  external_account_id: string | null;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  current_creditor: string | null;
  original_creditor: string | null;
  product: string | null;
  total_balance: number | null;
};

type Variables = {q: string};
type Data = ReachAccountSearchResult[];

const searchAccounts = async (variables: Variables): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/accounts/search", {
    params: {q: variables.q},
  });
  return response.data;
};

export const useSearchAccounts = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>([ACCOUNTS_SEARCH_QUERY_KEY, variables.q], searchAccounts, variables, options);
